"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const redux_1 = require("redux");
const isOverviewModalOpen = (state = 'open', action) => {
    switch (action.type) {
        case 'OPEN_OVERVIEW_MODAL':
            return 'open';
        case 'CLOSING_OVERVIEW_MODAL':
            return 'close';
        case 'CLOSED_OVERVIEW_MODAL':
            return 'closed';
        default:
            return state;
    }
};
const isArchiveModalOpen = (state = false, action) => {
    switch (action.type) {
        case 'ARCHIVE_MODAL_OPEN':
            return true;
        case 'ARCHIVE_MODAL_CLOSE':
            return false;
        default:
            return state;
    }
};
const isSendTestModalOpen = (state = 'open', action) => {
    switch (action.type) {
        case 'SET_SEND_TEST_MODAL_OPEN':
            return 'open';
        case 'SET_SEND_TEST_MODAL_CLOSE':
            return 'close';
        default:
            return state;
    }
};
const triggeredAnimation = (state = '', action) => {
    switch (action.type) {
        case 'TRIGGERED_ANIMATION':
            return action.trigger;
        default:
            return state;
    }
};
exports.default = redux_1.combineReducers({
    isOverviewModalOpen,
    isSendTestModalOpen,
    triggeredAnimation,
    isArchiveModalOpen,
});
exports.getIsOverviewModalOpen = (state) => state.isOverviewModalOpen;
exports.getIsArchiveModalOpen = (state) => state.isArchiveModalOpen;
exports.getIsSendTestModalOpen = (state) => state.isSendTestModalOpen;
exports.getTriggeredAnimation = (state) => state.triggeredAnimation;
